<template>
  <div>
    <div v-if="question.hasImages">
      <!-- This is the layout for picture groups -->
      <v-container class="white-background" fluid grid-list-md justify-center>
        <v-layout row wrap>
          <v-flex d-flex xs6 sm4 md4 lg3
            v-for="(item, index) in items"
            @click="setSelection(index)"
            class="pointer"
            :key="index"
          >
            <v-card
              class="rounded-card white-background" raised hover>
              <v-chip
                class="blue-text yellow-background"
                v-bind:class="{ 'popup-visible': value == index, 'popup-hidden': value != index, }" >
                <v-avatar><v-icon right>done</v-icon></v-avatar>
              </v-chip>
              <v-img
                aspect-ratio="1"
                position="center"
                align-center
                v-bind:class="{
                  'blue-background': value == index,
                  'white-background': value != index,
                }"
                :src="require('@/assets/choices/' + item.id + '.png')"
              ></v-img>
              <v-layout align-center justify-center row>
                <v-card-title class>
                  <h4 class="text-xs-center blue-text">
                    <span v-if="value == index"></span>
                    {{ item.title }}
                  </h4>
                </v-card-title>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-else>
      <!-- This is the layout for groups which do not all have pictures -->
      <!-- It's just a radio group with more emphatic text -->
      <v-radio-group
        v-model="answer.which"
        v-bind:column="!radiosInRow"
        class="blue-text"
      >
        <v-radio
          v-for="(item, index) in items"
          :key="index"
          :value="index"
          v-on:change="setSelection(index)"
        >
          <template slot="label">
            <h4 class="blue-text">{{ item.title }}</h4>
          </template>
        </v-radio>
      </v-radio-group>
    </div>
    <!-- Debug tools -->
    <v-card flat v-if="showTools">
      <v-card-actions>
        <v-btn text @click="applySavedValues">Apply saved values</v-btn>
        <v-btn text @click="applyTestValues(1)">Test(1)</v-btn>
        <v-btn text @click="clear">Clear</v-btn>
        <v-btn text v-for="(item, index) in items" :key="index" @click="setTo(index)">To {{index}}</v-btn>
        <v-card-text>userSet = {{ userSet }};  value = {{ value }}</v-card-text>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style >
@import "../assets/styles/styles.css";
</style>

<script>
import { overrideQuestionModel } from "../model/override-question-model.js";
export default {
  name: "RadioQuestion",
  props: {
    qid: String,
    showTools: Boolean
  },
  components: {},
  data: () => ({
  }),
  computed: {
    radiosInRow() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    question() {
      return overrideQuestionModel.getEnrichedQuestion(this.qid);
    },
    items() {
      return this.question.items;
    },
    answer() {
      return this.$store.state.enums.find((e) => e.id == this.qid);
    },
    value() {
      return this.answer.which
    },
    hasValue() {
      return this.answer.which >= 0;
    },
    userSet() {
      return this.answer.userSet;
    },
  },
  methods: {
    setSelection(index) {
      this.$store.commit("setEnum", {
        id: this.qid,
        index: index,
        userSet: true,
      });
      this.$emit('completed', index);
    },
    // Test methods
    applySavedValues() {
      this.$store.commit('applySavedValues', {whichSet: 1})
    },
    applyTestValues(whichSet) {
      this.$emit('testall', {whichSet: whichSet})
    },
    clear() {
      this.$store.commit("clearEnum", { id: this.qid });
    },
    setTo(index) {
      this.$store.commit("setEnum", {
        id: this.qid,
        index: index,
        userSet: false,
      });
    },
  },
};
</script>
